import React from "react";
import Login from "../pages/auth-pages/login";
import ResetPassword from "../pages/auth-pages/reset-password";
import Color from "../pages/color/index";
import Collection from "../pages/collection/index";
import Coupon from "../pages/settings/coupon/index";
import Notification from "../pages/settings/notification/index";
import Banner from "../pages/settings/banner/index";
import User from "app/pages/settings/user";

import Page from "@jumbo/shared/Page";
import AddUser from "app/pages/settings/user/add-update-user";
import AddRole from "app/pages/settings/role/add-update-role";
import Role from "app/pages/settings/role";
import PrivateRoute from "./PrivateRoute";
import Error404 from "app/pages/pagenotfound";
import Home from "app/pages/home/Home";
import Product from "app/pages/product";
import Permissions from "app/pages/settings/role/permission";
import Error401 from "app/pages/401";
import SetPassword from "app/pages/auth-pages/set-password";
import ChangePassword from "app/pages/auth-pages/change-password";
import {
  COLORS,
  COLLECTIONS,
  BANNERS,
  COUPONS,
  NOTIFICATIONS,
  HOME,
  MANAGE_PERMISSION,
  OFFICE_PRE_BOOK_ORDERS,
  PRODUCT_VARIANTS,
  PRODUCTS,
  OFFICE_PURCHASE_ORDERS,
  OFFICE_PURCHASE_ORDERS_ADD,
  OFFICE_RETURNS,
  OFFICE_RETURNS_ADD,
  OFFICE_RETURNS_EDIT,
  OFFICE_RETURN_ADD_FROM_PRE_ORDER,
  VENDORS,
  VENDORS_MANAGE_PRICE,
  ROLES,
  ROLES_ADD,
  ROLES_EDIT,
  USERS,
  USERS_ADD,
  USERS_EDIT,
  OFFICE_PURCHASE_ORDERS_EDIT,
  OFFICE_INVOICES,
  OFFICE_INVOICE_ADD,
  OFFICE_INVOICE_EDIT,
  MILL_ORDERS,
  MILL_ORDER_ADD,
  MILL_ORDER_EDIT,
  PRODUCT_ADD,
  PRODUCT_EDIT,
  OFFICE_ORDER_DISPATCHED,
  OFFICE_PRE_BOOK_ORDERS_ADD,
  OFFICE_PRE_BOOK_ORDERS_EDIT,
  MILL_PURCHASE,
  MILL_PURCHASE_ADD,
  MILL_PURCHASE_EDIT,
  KNITTER_ORDER,
  KNITTER_ORDER_ADD,
  KNITTER_ORDER_EDIT,
  OFFICE_PURCHASE_ADD_FROM_PRE_ORDER,
  OFFICE_INVOICE_Add_From_PO,
  MILL_PURCHASE_ADD_FROM_KNITTER_ORDER,
  LOGS_URL,
  OFFICE_ORDER_DISPATCHED_VIEW,
  PRODUCTS_INWARD,
  PRODUCTS_INWARD_ADD,
  PRODUCTS_LOW_STOCK,
  PRODUCTS_PROCESS_ADD,
  PRODUCTS_PROCESS,
  ALL_PRODUCTS,
  PARTY_RATE,
  PARTY_RATE_ADD,
  PARTY_RATE_PRODUCT_WISE,
  PARTY_NUMBER,
  PARTY_NUMBER_ADD,
  LEADS,
  LEAD_DETAIL,
} from "./constant";
import OfficeVendor from "app/pages/settings/vendor";
import ManagePrice from "app/pages/settings/vendor/manage-price";
import PurchaseOrder from "app/pages/office/purchase-order";
import AddAndUpdatePurchaseOrder from "app/pages/office/purchase-order/add-purchase-order";
import ReturnOrder from "app/pages/office/return";
import AddAndUpdateReturn from "app/pages/office/return/add-return";
import OrderPreBook from "app/pages/office/order-pre-book";
import Invoice from "app/pages/office/invoice";
import AddAndUpdateInvoice from "app/pages/office/invoice/add-edit-invoice";
import Order from "app/pages/mill/order";
import AddAndUpdateOrder from "app/pages/mill/order/add-edit-order";
import AddProduct from "app/pages/product/add-edit-product";
import ProductVariant from "app/pages/product/variant-list";
import DispatchedList from "app/pages/office/invoice/dispatched-list";
import AddAndUpdateOrderPrebook from "app/pages/office/order-pre-book/add-order-pre-book";
import MillPurchase from "app/pages/mill/purchase";
import AddAndUpdatePurchase from "app/pages/mill/purchase/add-edit-purchase";
import KnitterOrder from "app/pages/knitter/order";
import AddAndUpdateKnitterOrder from "app/pages/knitter/order/add-edit-order";
import Logs from "app/pages/logs";
import ProductInward from "app/pages/product/inward-list";
import ProductInwardAdd from "app/pages/product/add-product-inward";
import ProductVariantLowStock from "app/pages/product/low-stock";
import ProductProcessAdd from "app/pages/product/add-product-process";
import ProductProcess from "app/pages/product/process-list";
import AllProduct from "app/pages/product/all-product-list";
import PartyRate from "app/pages/partyRate";
import ProductWisePrice from "../pages/partyRate/product-wise-price";
import AddPartyRate from "app/pages/partyRate/add-party-rate";
import PartyNumber from "app/pages/partyNumber";
import AddPartyNumber from "app/pages/partyNumber/add-party-number";
import Lead from "app/pages/lead";
import LeadDetail from "app/pages/lead/lead-detail";

/**
 routes only accessible to authenticated users
 **/
const routesForAuthenticatedOnly = [
  {
    path: HOME,
    element: (
      <PrivateRoute>
        <Page component={Home} />
      </PrivateRoute>
    ),
  },
  {
    path: "/401",
    element: (
      <PrivateRoute>
        <Page component={Error401} />
      </PrivateRoute>
    ),
  },
  {
    path: COLORS,
    element: (
      <PrivateRoute permission="list-color">
        <Page component={Color} />
      </PrivateRoute>
    ),
  },
  {
    path: COLLECTIONS,
    element: (
      <PrivateRoute permission="list-collection">
        <Page component={Collection} />
      </PrivateRoute>
    ),
  },
  {
    path: BANNERS,
    element: (
      <PrivateRoute permission="list-banner">
        <Page component={Banner} />
      </PrivateRoute>
    ),
  },
  {
    path: COUPONS,
    element: (
      <PrivateRoute permission="list-coupon">
        <Page component={Coupon} />
      </PrivateRoute>
    ),
  },
  {
    path: NOTIFICATIONS,
    element: (
      <PrivateRoute permission="list-supplier-notification">
        <Page component={Notification} />
      </PrivateRoute>
    ),
  },
  {
    path: USERS,
    element: (
      <PrivateRoute permission="list-user">
        <Page component={User} />
      </PrivateRoute>
    ),
  },
  {
    path: USERS_ADD,
    element: (
      <PrivateRoute permission="create-user">
        <Page component={AddUser} />
      </PrivateRoute>
    ),
  },
  {
    path: USERS_EDIT,
    element: (
      <PrivateRoute permission="update-user">
        <Page component={AddUser} />
      </PrivateRoute>
    ),
  },
  {
    path: ROLES,
    element: (
      <PrivateRoute permission="list-role">
        <Page component={Role} />
      </PrivateRoute>
    ),
  },
  {
    path: ROLES_ADD,
    element: (
      <PrivateRoute permission="create-role">
        <Page component={AddRole} />
      </PrivateRoute>
    ),
  },
  {
    path: ROLES_EDIT,
    element: (
      <PrivateRoute permission="update-role">
        <Page component={AddRole} />
      </PrivateRoute>
    ),
  },

  {
    path: MANAGE_PERMISSION,
    element: (
      <PrivateRoute permission="manage-permission">
        <Page component={Permissions} />
      </PrivateRoute>
    ),
  },
  {
    path: "/change-password",
    element: (
      <PrivateRoute>
        <Page component={ChangePassword} />
      </PrivateRoute>
    ),
  },
  {
    path: VENDORS,
    element: (
      <PrivateRoute permission="list-supplier">
        <Page component={OfficeVendor} />
      </PrivateRoute>
    ),
  },
  {
    path: VENDORS_MANAGE_PRICE,
    element: (
      <PrivateRoute permission="manage-price-supplier">
        <Page component={ManagePrice} />
      </PrivateRoute>
    ),
  },
  {
    path: PRODUCTS,
    element: (
      <PrivateRoute permission="list-product">
        <Page component={Product} />
      </PrivateRoute>
    ),
  },
  {
    path: PARTY_RATE,
    element: (
      <PrivateRoute permission="list-supplier-rate">
        <Page component={PartyRate} />
      </PrivateRoute>
    ),
  },
  {
    path: PARTY_RATE_PRODUCT_WISE,
    element: (
      <PrivateRoute permission="list-supplier-rate">
        <Page component={ProductWisePrice} />
      </PrivateRoute>
    ),
  },
  {
    path: PARTY_RATE_ADD,
    element: (
      <PrivateRoute permission="create-supplier-rate">
        <Page component={AddPartyRate} />
      </PrivateRoute>
    ),
  },
  {
    path: PARTY_NUMBER,
    element: (
      <PrivateRoute permission="list-party-number">
        <Page component={PartyNumber} />
      </PrivateRoute>
    ),
  },
  {
    path: PARTY_NUMBER_ADD,
    element: (
      <PrivateRoute permission="create-party-number">
        <Page component={AddPartyNumber} />
      </PrivateRoute>
    ),
  },
  {
    path: ALL_PRODUCTS,
    element: (
      <PrivateRoute permission="list-product">
        <Page component={AllProduct} />
      </PrivateRoute>
    ),
  },
  {
    path: PRODUCT_EDIT,
    element: (
      <PrivateRoute permission="update-product">
        <Page component={AddProduct} />
      </PrivateRoute>
    ),
  },
  {
    path: PRODUCT_ADD,
    element: (
      <PrivateRoute permission="create-product">
        <Page component={AddProduct} />
      </PrivateRoute>
    ),
  },

  {
    path: PRODUCT_VARIANTS,
    element: (
      <PrivateRoute permission="list-variant">
        <Page component={ProductVariant} />
      </PrivateRoute>
    ),
  },
  {
    path: PRODUCTS_LOW_STOCK,
    element: (
      <PrivateRoute permission="list-variant">
        <Page component={ProductVariantLowStock} />
      </PrivateRoute>
    ),
  },
  {
    path: PRODUCTS_INWARD,
    element: (
      <PrivateRoute permission="list-product">
        <Page component={ProductInward} />
      </PrivateRoute>
    ),
  },
  {
    path: PRODUCTS_INWARD_ADD,
    element: (
      <PrivateRoute permission="update-product">
        <Page component={ProductInwardAdd} />
      </PrivateRoute>
    ),
  },
  {
    path: PRODUCTS_PROCESS,
    element: (
      <PrivateRoute permission="list-product">
        <Page component={ProductProcess} />
      </PrivateRoute>
    ),
  },
  {
    path: PRODUCTS_PROCESS_ADD,
    element: (
      <PrivateRoute permission="update-product">
        <Page component={ProductProcessAdd} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_PURCHASE_ORDERS,
    element: (
      <PrivateRoute permission="list-purchase-order">
        <Page component={PurchaseOrder} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_PURCHASE_ORDERS_ADD,
    element: (
      <PrivateRoute permission="create-purchase-order">
        <Page component={AddAndUpdatePurchaseOrder} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_PURCHASE_ORDERS_EDIT,
    element: (
      <PrivateRoute permission="update-purchase-order">
        <Page component={AddAndUpdatePurchaseOrder} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_RETURNS,
    element: (
      <PrivateRoute permission="list-return">
        <Page component={ReturnOrder} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_RETURNS_ADD,
    element: (
      <PrivateRoute permission="create-return">
        <Page component={AddAndUpdateReturn} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_RETURNS_EDIT,
    element: (
      <PrivateRoute permission="update-return">
        <Page component={AddAndUpdateReturn} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_RETURN_ADD_FROM_PRE_ORDER,
    element: (
      <PrivateRoute permission="create-return">
        <Page component={AddAndUpdateReturn} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_PURCHASE_ADD_FROM_PRE_ORDER,
    element: (
      <PrivateRoute permission="create-purchase-order">
        <Page component={AddAndUpdatePurchaseOrder} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_INVOICES,
    element: (
      <PrivateRoute permission="list-invoice">
        <Page component={Invoice} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_INVOICE_ADD,
    element: (
      <PrivateRoute permission="create-invoice">
        <Page component={AddAndUpdateInvoice} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_INVOICE_Add_From_PO,
    element: (
      <PrivateRoute permission="create-invoice">
        <Page component={AddAndUpdateInvoice} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_INVOICE_EDIT,
    element: (
      <PrivateRoute permission="update-invoice">
        <Page component={AddAndUpdateInvoice} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_ORDER_DISPATCHED_VIEW,
    element: (
      <PrivateRoute permission="dispatched-invoice">
        <Page component={AddAndUpdateInvoice} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_ORDER_DISPATCHED,
    element: (
      <PrivateRoute permission="dispatched-invoice">
        <Page component={DispatchedList} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_PRE_BOOK_ORDERS,
    element: (
      <PrivateRoute permission="list-pre-book">
        <Page component={OrderPreBook} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_PRE_BOOK_ORDERS_ADD,
    element: (
      <PrivateRoute permission="create-pre-book">
        <Page component={AddAndUpdateOrderPrebook} />
      </PrivateRoute>
    ),
  },
  {
    path: OFFICE_PRE_BOOK_ORDERS_EDIT,
    element: (
      <PrivateRoute permission="update-pre-book">
        <Page component={AddAndUpdateOrderPrebook} />
      </PrivateRoute>
    ),
  },
  {
    path: MILL_ORDERS,
    element: (
      <PrivateRoute permission="list-mill-order">
        <Page component={Order} />
      </PrivateRoute>
    ),
  },
  {
    path: MILL_ORDER_ADD,
    element: (
      <PrivateRoute permission="create-mill-order">
        <Page component={AddAndUpdateOrder} />
      </PrivateRoute>
    ),
  },
  {
    path: MILL_ORDER_EDIT,
    element: (
      <PrivateRoute permission="update-mill-order">
        <Page component={AddAndUpdateOrder} />
      </PrivateRoute>
    ),
  },
  {
    path: MILL_PURCHASE,
    element: (
      <PrivateRoute permission="list-mill-purchase">
        <Page component={MillPurchase} />
      </PrivateRoute>
    ),
  },
  {
    path: MILL_PURCHASE_ADD,
    element: (
      <PrivateRoute permission="create-mill-purchase">
        <Page component={AddAndUpdatePurchase} />
      </PrivateRoute>
    ),
  },
  {
    path: MILL_PURCHASE_ADD_FROM_KNITTER_ORDER,
    element: (
      <PrivateRoute permission="create-mill-purchase">
        <Page component={AddAndUpdatePurchase} />
      </PrivateRoute>
    ),
  },
  {
    path: MILL_PURCHASE_EDIT,
    element: (
      <PrivateRoute permission="update-mill-purchase">
        <Page component={AddAndUpdatePurchase} />
      </PrivateRoute>
    ),
  },
  {
    path: KNITTER_ORDER,
    element: (
      <PrivateRoute permission="list-knitter-order">
        <Page component={KnitterOrder} />
      </PrivateRoute>
    ),
  },
  {
    path: LOGS_URL,
    element: (
      <PrivateRoute permission="list-accountLog">
        <Page component={Logs} />
      </PrivateRoute>
    ),
  },
  {
    path: KNITTER_ORDER_ADD,
    element: (
      <PrivateRoute permission="create-knitter-order">
        <Page component={AddAndUpdateKnitterOrder} />
      </PrivateRoute>
    ),
  },
  {
    path: KNITTER_ORDER_EDIT,
    element: (
      <PrivateRoute permission="update-knitter-order">
        <Page component={AddAndUpdateKnitterOrder} />
      </PrivateRoute>
    ),
  },
  {
    path: LEADS,
    element: (
      <PrivateRoute permission="list-lead">
        <Page component={Lead} />
      </PrivateRoute>
    ),
  },
  {
    path: LEAD_DETAIL,
    element: (
      <PrivateRoute permission="list-lead">
        <Page component={LeadDetail} />
      </PrivateRoute>
    ),
  },
];

/**
 routes only accessible when user is anonymous
 **/
const routesForNotAuthenticatedOnly = [
  {
    path: "/login",
    element: <Page component={Login} layout={"solo-page"} />,
  },
  {
    path: "/reset-password",
    element: <Page component={ResetPassword} layout={"solo-page"} />,
  },
  {
    path: "/set-password",
    element: <Page component={SetPassword} layout={"solo-page"} />,
  },
  {
    path: "*",
    element: (
      <Page component={Error404} layout={"solo-page"} disableSmLogin={true} />
    ),
  },
];

const routes = [
  ...routesForAuthenticatedOnly,
  ...routesForNotAuthenticatedOnly,
];

export {
  routes as default,
  routesForNotAuthenticatedOnly,
  routesForAuthenticatedOnly,
};
